import React from "react";

const OrdersNotFound = ({ restaurantsLink }) => (
  <>
    <div className="profile-desktop container">
      <div className="hide-xs">
        <h4 className="general-title d-flex align-items-center justify-content-between">
          <span>Your Orders</span>
        </h4>
      </div>

      <div className="white-bg mt-10px empty-body">
        <div className="empty-img">
          <img src="/png/no-order.png" alt="" />
        </div>
        <p>No orders yet.</p>
        <a
          href={restaurantsLink}
          className="hide-xs btn btn-blue d-flex justify-content-center align-items-center"
        >
          <span>Browse Restaurants</span>
        </a>
      </div>
    </div>

    <a
      href={restaurantsLink}
      style={{ margin: "20px 20px 0" }}
      className="visible-xs btn btn-blue d-flex justify-content-center align-items-center"
    >
      <span>Browse Restaurants</span>
    </a>
  </>
);

export default OrdersNotFound;
